import axios from 'axios'
import Modal from 'ant-design-vue/es/modal'

const instance = axios.create();

instance.interceptors.request.use(res => {
  const token = localStorage.getItem('token');
  if (token) {
    res.headers = {
      ...res.headers,
      token,
      Authorization:token
    }
  }
  return res;
}, err => {
  return err;
})

instance.interceptors.response.use(res => {
  if (res.status == 200) {
    return Promise.resolve(res.data);
  }
  else if (res.status == 400) {
    Modal.error({
      title: '错误',
      content: res.data.msg,
    });
    location.pathname = '/login';
    localStorage.clear()
    // Promise.reject(res)
  }
  else {
    return Promise.reject(res);
  }
}, err => {
  return Promise.reject(err);
})

export default instance;